module.exports = __webpack_public_path__ + "static/media/oblong_c.bf7e99b1.svg";